import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitRequestListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.request.list);
  };

  return (
    <MainMenuItem
      itemTitleString="美容室へ発送する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitRequestListMenuItem;
